<div *ngFor="let appointmentSlot of appointmentSlots; let i = index" [@listAnimation]="state">
  <booked-appointments-component [appointmentSlot]=appointmentSlot></booked-appointments-component>
</div>